import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DataStoreService {
  private _allStepsData = {};
  private countryCode: string;
  private selectedValue = {};
  private allStepData;
  private type;
  uploadAllFileSize = 0;
  countryList: any;
  set(name: string, data): void {
   // data.uiStructure=this.delete(data.uiStructure)
    try {
      this._allStepsData['' + name] = JSON.parse(JSON.stringify(data, this.replacer, 4));
    } catch (error) {
      console.log(error);
    }
  }

  // delete(obj) {
  //   Object.keys(obj).forEach(res => {
  //     if (res == 'containerRef') {
  //       delete obj.containerRef;
  //     } else if(obj[res] instanceof Object) {
  //       this.delete(obj[res])
  //     }
  //   })
  //   return obj
  // }
  replacer(key: string, value: any) {
      let valueAsString = value;
        if (this[key] instanceof Date || typeof this[key] === 'function') {
          valueAsString = this[key].toString();
        } else if (key === 'refElement' || key === 'containerRef' || key === 'componentRef') {
          this[key] = undefined;
        }
        return this[key] === undefined ? null : valueAsString;
       }
    
  get(name: string): any {
    return this._allStepsData['' + name];
  }


  setCountryList(data){
    this.countryList=data
  }

 
  getCountryList(){
    return this.countryList;
  }
 

  clear(): void {
    this._allStepsData = {};
  }

  /**
 * Used for Title and email salutation (After Dear in email)
 * @param type -Firstname, lastname or fullname
 * @returns 
 */
 getInsuredName(type):string {
  const uiData=this.get('fnol-claimant-info')['uiData'];
  if(type === 'firstName'){
    return  uiData['completeClaim']['value'] === "insurer"? uiData['insuredFirstName']:uiData['firstName'];
  } else if(type === 'lastName'){
    return uiData['completeClaim']['value'] === "insurer"?uiData['insuredLastName']: uiData['lastName'];
  } else if(type ==="fullName"){
    return uiData['completeClaim']['value'] === "insurer"? uiData['insuredFirstName'] + " "+ uiData['insuredLastName'] :uiData['firstName']+" "+ uiData['lastName'];
  }
 }

  setDataClear() {
    this.allStepData = {};
    this.type = null;
    this._allStepsData = {};
  }

  setCountryCode(countryCode): void {
    this.countryCode = countryCode;
  }

  getCountryCode(): string {
    return this.countryCode;
  }
  getAllStepData(): Array<any> {
    return this.allStepData;
  }


  setAllStepData(allStepData): void {
    this.allStepData = allStepData;
  }
  setType(type: string) {
    this.type = type;
  }
  getType() {
    return this.type;
  }
  clearPaymentDocument(): void {
    delete this._allStepsData['' + 'fnol-payment-details']
    delete this._allStepsData['' + 'fnol-upload-docs']
  }
  setSelectedData(selectedValue): void {
    this.selectedValue = selectedValue;
  }
  getSelectedData() {
    return this.selectedValue;
  }

  getuploadAllFileSize() {
    return this.uploadAllFileSize
  }

  setuploadAllFileSize(e) {
    this.uploadAllFileSize = e
  }
  checkAutoComplete(value) {
    if ( value && typeof value === 'object' && value?.autoCompleteAddress) {
      return (value['name'] || value?.autoCompleteAddress)
    } else {
      return value
    }
  }
  constructor() { }
}
